<template>
  <TopGradientBlockLayout>
    <template #top>
      <div class="flex items-center flex-wrap">
        <div class="text-xl font-bold text-text leading-tight w-full mb-8">
          {{ $t('pageTitle') }}
        </div>
        <TrashMenu :summary="trashSummary"
                   :current-active="menuActive"
                   @select="menuActive = $event"/>
      </div>
    </template>
    <template v-if="menuActive">
      <div class="text-xl font-bold text-text leading-tight w-full mb-4">
        {{ $t('listTitle') }} {{ $t(`listLabels.${menuActive}`) }}
      </div>
      <div v-if="trashList.dirty" class="text-center pt-10">
        <font-awesome-icon class="text-primary text-xl text-center" icon="circle-notch" spin/>
      </div>
      <TrashList v-else
                 :list-item-type="menuActive"
                 :list="trashList.data"
                 :loading="trashList.dirty"
                 @itemRestored="updateList"/>
      <div class="mt-10" v-show="current_page < pages_length || more_loading">
      <span v-if="!more_loading"
            class="text-2sm text-text-ternary cursor-pointer border-b border-dashed border-text-ternary
                   transition duration-200 hover:text-red hover:border-red"
            @click="showMore">
        {{ $t('showMore') }}
      </span>
        <font-awesome-icon v-else class="text-primary" icon="circle-notch" spin/>
      </div>
    </template>
    <template v-else-if="!menuActive && trashIsEmpty">
      <div class="text-xl font-bold text-text text-center leading-tight w-full mb-4">
        {{ $t('trashIsEmpty') }}
      </div>
    </template>
  </TopGradientBlockLayout>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import TrashList from "@/components/cabinet/SpaceSettings/Trash/TrashList";
import TrashMenu from "@/components/cabinet/SpaceSettings/Trash/TrashMenu";

export default {
  name: "Trash",
  components: {TrashMenu, TrashList, TopGradientBlockLayout},
  data() {
    return {
      menuActive: null,
      more_loading: false
    }
  },
  computed: {
    ...mapState('space/trash', ['trashSummary', 'trashList']),
    ...mapState('space/trash', {
      loading: state => state.trashList.dirty,
      current_page: state => state.trashList.pagination.current_page,
      pages_length: state => state.trashList.pagination.pages
    }),
    trashIsEmpty() {
      if(!this.trashSummary) return false;
      return Object.values(this.trashSummary).every(item => item === 0);
    }
  },
  methods: {
    ...mapActions('space/trash', ['fetchSummary', 'fetchTrashItems', 'fetchTrashItemsMore']),
    ...mapMutations('space/trash', ['setTrashListPage']),
    showMore() {
      this.setTrashListPage(this.current_page + 1)
    },
    async updateList() {
      await this.fetchSummary();
      await this.fetchTrashItems(this.menuActive);
    }
  },
  watch: {
    menuActive: {
      handler(val) {
        this.fetchTrashItems(val);
      }
    },
    current_page(newVal) {
      if (newVal === 1) {
        this.fetchTrashItems(this.menuActive)
      } else {
        this.more_loading = true
        this.fetchTrashItemsMore(this.menuActive)
        this.more_loading = false
      }
    }
  },
  async created() {
    await this.fetchSummary();
    let anyMenuHasItemsIndex = Object.values(this.trashSummary).findIndex(item => item > 0);
    if (anyMenuHasItemsIndex !== -1) {
      this.menuActive = Object.keys(this.trashSummary)[anyMenuHasItemsIndex]
    }
  },
  i18n: {
    messages: {
      en: {
        pageTitle: 'Trash',
        listTitle: 'Deleted',
        listLabels: {
          transactions: 'transactions',
          accounts: 'accounts',
          expenseCategories: 'expense categories',
          incomeSources: 'income sources',
          contractors: 'contractors',
          portfolios: 'investment portfolios',
        },
        showMore: 'Show more',
        trashIsEmpty: 'Your trash is empty'
      },
      ru: {
        pageTitle: 'Корзина',
        listTitle: 'Удаленные',
        listLabels: {
          transactions: 'операции',
          accounts: 'счета',
          expenseCategories: 'категории расходов',
          incomeSources: 'источники доходов',
          contractors: 'контрагенты',
          portfolios: 'инвестпортфели',
        },
        showMore: 'Показать больше',
        trashIsEmpty: 'Ваша корзина пуста'
      }
    }
  }
}
</script>